import { KRPANO_SETTING } from '~js/constants'
import gaEvents from '~js/ga-events'
import { HOTSPOT_BASE_SIZE } from '@/api/constants'
import { clamp, divide } from 'lodash'

let autoStartAutoRotateTimer
const hooks = (vm, store) => {
  const { getters } = store
  return {
    async convertGifToSprite () {
      return await vm.convertGifToSprite()
    },
    async setMarkerImageInfos () {
      return await vm.setMarkerImageInfos()
    },
    getCurrentPanoramaId () {
      return getters.currentPanorama.objectId
    },
    getGifInfos () {
      return getters.markerGifInfos
    },
    getImageInfos () {
      return getters.markerImageInfos
    },
    getResizeSize (size) {
      const ratio = divide(size.width, size.height)
      const ifResizeWidth = ratio < 1 // Width is shorter than height
      let resizeWidth = HOTSPOT_BASE_SIZE
      let resizeHeight = (HOTSPOT_BASE_SIZE / ratio).toFixed(1)
      if (ifResizeWidth) {
        resizeWidth = (HOTSPOT_BASE_SIZE * ratio).toFixed(1)
        resizeHeight = HOTSPOT_BASE_SIZE
      }
      resizeWidth = Number(resizeWidth)
      resizeHeight = Number(resizeHeight)
      return { resizeWidth, resizeHeight }
    },
    getFrameRate (frameLength) {
      return clamp(frameLength, 0, 30)
    },
    startAutoRun (revert = false) {
      clearTimeout(autoStartAutoRotateTimer)
      if (getters.useAutopilot) {
        vm.startAutoRotate()
      } else {
        autoStartAutoRotateTimer = setTimeout(() => {
          vm.startAutoRotate({ revert })
        }, KRPANO_SETTING.time.autoStartAutoRotate * 1000)
      }
    },
    startAutoRotate (bool = false) {
      vm.startAutoRotate({
        revert: bool
      })
    },
    stopAutoRotate (bool = false) {
      vm.stopAutoRotate({
        shouldAutoStartRotate: bool
      })
    },
    prepareChangeScene (nextPanoramaName = '', nextPanoramaId = '', selectedMethod = '', nextPanoramaRotation = 0, isMarkerPoint = false, markerAth = 0, objectId) {
      const oldIndex = vm.panoramas.findIndex(panorama => panorama.objectId === vm.currentPanorama.objectId)
      const newIndex = vm.panoramas.findIndex(panorama => panorama.objectId === nextPanoramaId)
      if (newIndex > -1) {
        if (objectId !== 'null') {
          gaEvents.sendEvent('Marker', 'PointClicks', objectId)
        }
        const oldHLookat = vm.krpanoLookAtH
        window.krpanoObj.call(`change_scene(${nextPanoramaName}, ${nextPanoramaId}, ${selectedMethod}, ${nextPanoramaRotation},
          ${isMarkerPoint}, ${markerAth}, ${newIndex}, ${oldIndex}, ${oldHLookat}, ${vm.isGyroEnabled});`)
      }
    },
    changeImage (nextPanoramaId, selectedMethod, isMarkerPoint, isWebVr) {
      vm.selectPanorama(nextPanoramaId, selectedMethod, isMarkerPoint, isWebVr)
    },
    // threeJsMoving (nextPanoramaRotation = 0, markerAth = 0, newIndex, oldIndex, oldHLookat = 0) {
    //   window.animationStart = true
    //   window.build_scene(nextPanoramaRotation, markerAth, newIndex, oldIndex, oldHLookat)
    // },
    // threeJsMovingStop () {
    //   window.animationStart = false
    // },
    markerMousein (index = 0, mouseX = 0, mouseY = 0) {
      vm.krpanoMarkerMousein(index, mouseX, mouseY)
    },
    markerMouseout (index) {
      vm.krpanoMarkerMouseout(index)
    },
    setMarkerInfo (index) {
      vm.setMarkerInfo(index)
    },
    setMarkerNarration (index) {
      vm.setMarkerNarration(index)
    },
    setSearchSetting (index) {
      vm.setSearchSetting(index)
    },
    changeCamera (h, v, fov) {
      vm.setKrpanoCamera({ h, v, fov })
    },
    handleShowPopup (index) {
      vm.handleShowPopup(index)
    },
    isVrMode () {
      return getters.isVrMode
    },
    exitVrMode () {
      vm.exitVrMode()
    },
    clickKrpanoScreen () {
      // if (this.shouldEnterClosestPointMarker()) {
      //   if (vm.krpanoEl) {
      //     window.krpanoObj.call(`enter_closest_point_marker();`)
      //   }
      // }
    },
    shouldEnterClosestPointMarker () {
      // if (vm.krpanoEl) {
      //   if (vm.$route.name === 'yung-ching') {
      //     if (vm.isPanoramasListActive ||
      //       (window.innerWidth < 768 && (vm.isFloorplanActive || vm.isPanoramasListActive))) {
      //       // 768 = CSS assets/css/variables.styl $response value
      //       return false
      //     }
      //   } else if (window.innerWidth < 768 &&
      //     (vm.isFloorplanActive || vm.isPanoramasListActive)) {
      //     // 768 = CSS assets/css/variables.styl $response value
      //     return false
      //   } else if (vm.isMarkerInfoActive ||
      //     vm.isInformationActive ||
      //     vm.isCommentsActive ||
      //     vm.isShareActive) {
      //     return false
      //   }
      //   return true
      // }
      // return false
    },
    findClosestPointMarker (mAth, mAtv, callback) {
      // if (vm.currentPanorama.markers) {
      //   const points = vm.currentPanorama.markers.filter(marker => marker.type === 'point')
      //   if (points) {
      //     let closestDistance = 3600
      //     let closestPoint = null
      //     let closestAth
      //     const { x: mX, y: mY, z: mZ } = coords2dTo3d({ ath: mAth, atv: mAtv })
      //     // console.log('mouse position 2d', mAth, mAtv)
      //     // console.log('mouse position 3d', mX, mY, mZ)
      //     points.forEach(point => {
      //       let { ath, atv } = coords3dTo2d(point.position)
      //       ath = setCorrectRotation(ath + vm.krpanoXOffset)
      //       const { x, y, z } = coords2dTo3d({ ath, atv })
      //       const distance = Math.sqrt(Math.pow(mX - x, 2) + Math.pow(mY - y, 2) + Math.pow(mZ - z, 2))
      //       // console.log('point position 3d', x, y, z, vm.nextPanoramaCategoryName(point))
      //       // console.log('distance', distance)
      //       if (closestDistance > distance) {
      //         closestDistance = distance
      //         closestPoint = point
      //         closestAth = ath
      //       }
      //     })
      //     // console.log('closestDistance', closestDistance)
      //     // console.log('closestPoint', closestPoint)
      //     // console.log('next point', vm.nextPanoramaCategoryName(closestPoint))
      //     if (callback && typeof callback === 'function' && callback instanceof Function) {
      //       callback(closestPoint, closestAth)
      //     } else {
      //       return { closestPoint, closestAth }
      //     }
      //   }
      // }
    },
    enterClosestPointMarker (marker, closestAth) {
      // if (marker) {
      //   window.krpanoObj.call(`prepare_change_scene(panorama_${marker.nextPanoramaId}, ${marker.nextPanoramaId}, 'Screen', ${vm.krpanoXOffset - (marker.nextRotation ? marker.nextRotation.y : 0)}, true, ${closestAth}`)
      // }
    },
    hoverClosestPointMarker (closestPoint) {
      // if (vm.currentPanorama.markers) {
      //   const points = vm.currentPanorama.markers.filter(marker => marker.type === 'point')
      //   if (points) {
      //     if (vm.currentMarker && vm.currentMarker.objectId && vm.currentMarker.type !== 'point') {
      //       // has already hovered in a tag/memo/popup marker, so un-hover all point markers
      //       points.forEach(marker => {
      //         window.krpanoObj.call(`marker_fadeout(${marker.objectId})`)
      //       })
      //     } else {
      //       // hover focused point marker and un-hover other point markers
      //       const otherPoints = points.filter(marker => marker.objectId !== closestPoint.objectId)
      //       if (otherPoints) {
      //         otherPoints.forEach(marker => {
      //           window.krpanoObj.call(`marker_fadeout(${marker.objectId})`)
      //         })
      //       }
      //       if (closestPoint) {
      //         window.krpanoObj.call(`marker_fadein(${closestPoint.objectId})`)
      //       }
      //     }
      //   }
      // }
    },
    changeBuilding (nextBuildingId, nextBuildingIndex = 1, objectId) {
      vm.changeBuilding(nextBuildingId, nextBuildingIndex, objectId)
    },
    resolve (...args) {
      vm.resolve(...args)
    },
    emit (...args) {
      vm.emit(...args)
    }
  }
}

export default hooks
